
import Vue from "vue";

export default Vue.extend({
  name: "TruncatedTextCell",
  props: {
    text: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: [String, Number],
      default: 200
    },
    maxLines: {
      type: Number,
      default: 1
    },
    preserveFormatting: {
      type: Boolean,
      default: false
    },
    showNullAs: {
      type: String,
      default: "-"
    }
  },
  data() {
    return {
      dialogOpen: false,
      hasOverflow: false,
      snackbar: false
    };
  },
  computed: {
    displayText(): string {
      if (this.text === null || this.text === undefined || this.text === "") {
        return this.showNullAs;
      }
      return String(this.text);
    },
    cellStyle(): Record<string, string> {
      const width = typeof this.maxWidth === "number" 
        ? `${this.maxWidth}px` 
        : this.maxWidth;
      
      return {
        maxWidth: width,
        WebkitLineClamp: String(this.maxLines)
      };
    }
  },
  mounted() {
    this.checkOverflow();
    // Re-check on window resize
    window.addEventListener("resize", this.checkOverflow);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkOverflow);
  },
  watch: {
    text() {
      this.$nextTick(() => {
        this.checkOverflow();
      });
    }
  },
  methods: {
    checkOverflow() {
      const el = this.$refs.cellContent as HTMLElement;
      if (el) {
        // Check if text is truncated
        this.hasOverflow = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
      }
    },
    handleClick() {
      if (this.hasOverflow && this.text) {
        this.dialogOpen = true;
      }
    },
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(String(this.text));
        this.snackbar = true;
      } catch (err) {
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = String(this.text);
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        this.snackbar = true;
      }
    }
  }
});
